import React from "react";
import styled from "styled-components";
import {Button} from "react-bootstrap";
import AvatarImage from "../assets/avatarImage5.jpg";


function Navbar() {
  const logout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    window.location.href = "/";
  }
  const upload = () => {
    window.location.href = "/upload";
  }
  return (
    <NavbarContainer>
      <Text>
        Search Boiler Trade
      </Text>
      <Avatar>
        {/* <img src={AvatarImage} alt="" /> */}
        <ButtonContainer>
          <Button onClick={() => { logout() }}> logout </Button>
          <Button onClick={() => { upload() }}> Upload Your Product </Button>
        </ButtonContainer>
        
        {/* <span> logout </span> */}
      </Avatar>
      

    </NavbarContainer>
  );
}

const NavbarContainer = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #2E4765;
  height: 10%;
  @media screen and (min-width: 320px) and (max-width: 1080px) {
    flex-direction: column;
    margin-bottom: 1rem;
  }
`;

const ButtonContainer = styled.nav`
  Button {
    margin: 5px;
  }
`;

const Text = styled.h1`
  span {
    font-weight: 500;
    color: #484258;
  }
  @media screen and (min-width: 320px) and (max-width: 1080px) {
    margin-top: 1rem;
  }
`;
const InputContainer = styled.div`
  display: flex;
`;

const Icon = styled.div`
  height: 3rem;
  width: 3rem;
  background-color: #dce4ff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-top-left-radius: 0.5rem;
  border-bottom-left-radius: 0.5rem;
  svg {
    color: #555555;
  }
`;
const Input = styled.input`
  border: none;
  background-color: #dce4ff;
  border-top-right-radius: 0.5rem;
  border-bottom-right-radius: 0.5rem;
  color: #464646;

  &:focus {
    border: none;
    outline: none;
  }
`;

const Avatar = styled.div`
  img {
    height: 3.5rem;
    width: 3.5rem;
    border-radius: 3.5rem;
  }
`;

export default Navbar;
